const NotFoundPage = (props) => {
  return <div>404</div>;
};
export default NotFoundPage;
